import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ProjetAgenceModel, ProjetSchemaDescrModel } from 'src/app/shared/models/simple-types/projet-models.model';
import { SchemaForms } from 'src/app/shared/models/simple-types/projet-models.model';
import { DemandeAgenceService } from 'src/app/shared/services/agence-linked/demande-agence.service';
import { AgenceService } from 'src/app/shared/services/rsa/agence.service';
import { ProjetAgenceService } from 'src/app/shared/services/simple/projet-agence.service';
import { ProjetSchemaService } from 'src/app/shared/services/simple/projet-schema.service';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { SessionService } from 'src/app/shared/services/session.service';
import { UtilisateurModel } from 'src/app/shared/models/utilisateur/utilisateur.model';
import { FormlyGroup } from '@ngx-formly/core/lib/templates/formly.group';
import { ModalModifFormlyComponent } from '../../modals/modal-modif-formly/modal-modif-formly.component';

@Component({
  selector: 'app-display-projet-agence',
  templateUrl: './display-projet-agence.component.html',
  styleUrls: ['./display-projet-agence.component.scss']
})
export class DisplayProjetAgenceComponent {
  constructor(
    public dialog: MatDialog,
    private agenceService: AgenceService,
    private toastr: ToastrService,
    private demandeAgenceService: DemandeAgenceService,
    private projetSchemaService: ProjetSchemaService,
    private projetAgenceService: ProjetAgenceService,
    private sessionService: SessionService,
  ) {}

  @Input() projetSchemaDescr: ProjetSchemaDescrModel;
  @Input() form: FormGroup;
  @Input() allProjetAgence: ProjetAgenceModel[] = [];
  @Input() disabled: boolean = true;
  @Input() agenceId;
  @Output() changeProjetEmit = new EventEmitter<boolean>();

  projetAgence: ProjetAgenceModel;
  model: any;
  schema: FormlyFieldConfig[];
  empty = false;
  emailModifieurs: string[];
  emailModifieursTxt: string = "Modifieurs : aucun";
  currentUser: UtilisateurModel;
  droitModif: boolean = false;
  isAppliedColumns = false;

  ngOnInit() {
    this.sessionService.currentUser.subscribe(user => {
      this.currentUser = user;
      this.checkDroitModif();
    });
    this.initSchema();
    this.initModel();
    this.applyDisabledAndHide();
  }

  checkDroitModif() {
    this.droitModif = this.emailModifieurs?.find(emailModifieur => emailModifieur == this.currentUser?.email) ? true : false;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.projetSchemaDescr) {
      this.initSchema();
      this.initModel();
      this.applyDisabledAndHide();
    } else if (changes.allProjetAgence || changes.agenceId) {
      this.initModel();
    } if (changes.disabled) {
      this.applyDisabledAndHide();
    }
  }

  modelChanges(model) {
    this.projetAgence.projet = JSON.stringify(model);
    this.model = model;
  }

  initSchema() {
    if (this.projetSchemaDescr?.schema) {
      this.schema = JSON.parse(this.projetSchemaDescr.schema);
      this.emailModifieurs = JSON.parse(this.projetSchemaDescr.mailModifieurs);
      this.emailModifieursTxt = "Modifieur : aucun";
      for (let i = 0 ; i < this.emailModifieurs?.length ; i++) {
        if (i == 0) {
          this.emailModifieursTxt = "Modifieur" + (this.emailModifieurs.length > 1 ? "s" : "")  + " :\n";
        }
        if (i > 0)
          this.emailModifieursTxt += ",\n";
        this.emailModifieursTxt += this.emailModifieurs[i].trim();
      }
      this.checkDroitModif();
      this.applyColumns();
    }
  }

  initModel() {
    this.projetAgence = this.allProjetAgence.find(x => x.idProjetSchemaDescr == this.projetSchemaDescr.id);
    if (!this.projetAgence) {
      this.projetAgence = new ProjetAgenceModel();
      this.projetAgence.idAgence = this.agenceId;
      this.projetAgence.idProjetSchemaDescr = this.projetSchemaDescr.id;
      this.projetAgence.projetSchemaDescr = Object.assign({}, this.projetSchemaDescr);
      this.projetAgence.projet = JSON.stringify("");
      this.empty = true;
    }
    this.model = JSON.parse(this.projetAgence.projet);
  }

  applyDisabledAndHide()
  {
    if (this.projetSchemaDescr?.schema && this.disabled != null && this.disabled != undefined) {
      this.schema.map((field: FormlyFieldConfig) => {
        this.applyDisableAndHideOnElem(field);
      });
      this.projetSchemaDescr.schema = JSON.stringify(this.schema);
    }
  }

  applyDisableAndHideOnElem(elemFieldConfig) {
    if (elemFieldConfig?.props)
      elemFieldConfig.props.disabled = this.disabled;
    if (elemFieldConfig?.props?.hideIfEmpty) {
      elemFieldConfig.expressions = {
        hide: (field: FormlyFieldConfig) => {
          return this.evalHide(elemFieldConfig);
        }
      };
    }
    if (elemFieldConfig?.fieldGroup) {
      elemFieldConfig?.fieldGroup.map((subfield: FormlyFieldConfig) => {
        this.applyDisableAndHideOnElem(subfield);
      });
    }
  }

  evalHide(elemFieldConfig) {
    let hideIfEmpty = elemFieldConfig?.props?.hideIfEmpty ? true : false;
    let ret = hideIfEmpty && !this.model[elemFieldConfig.key] && this.disabled;
    return ret;
  }

  onclickButton(){
    const addForm = this.dialog.open(ModalModifFormlyComponent, {
      data: {
        title: 'Modification de formulaire',
        subTitle: this.projetSchemaDescr.libelle,
        //footer: 'Je déclare avoir fait attention à la séparation des taches',
        //type: 'Demande',
        //message: "Message",//modifs,
        icone: 'warning',
        iconColor: 'warn',
        color: 'success',
        projetSchemaDescr: Object.assign({}, this.projetSchemaDescr),
        model: Object.assign({}, this.model),
        projetAgence: Object.assign({}, this.projetAgence),
      },
      autoFocus: false,
      maxHeight: '90vh'
    });
    addForm.afterClosed().subscribe((res) => {
      if (res) {
        this.form = res.form;
        this.projetAgence = res.projetAgence;
        this.model = res.model;
        this.changeProjetEmit.next(true);
      }
    });
  }

  applyColumns()
  {
    if (!this.isAppliedColumns && this.projetSchemaDescr?.schema) {
      let fieldGr: FormlyFieldConfig[] = [];
      let newSchem: FormlyFieldConfig[] = [];
      for (let i = 0 ; i < this.schema.length ; i++) {
        if (!this.schema[i].className){
          this.schema[i].className = "col-3";
        }
        fieldGr.push(this.schema[i]);
      }
      newSchem.push({fieldGroup: fieldGr, fieldGroupClassName: "row"});
      this.schema = newSchem;
      this.projetSchemaDescr.schema = JSON.stringify(this.schema);
      this.isAppliedColumns = true;
    }
  }
}
